import {useCallback, useState} from 'react';

export const useBoolean = (initial = false) => {
    const [value, setValue] = useState(initial);

    const on = useCallback(() => {
        setValue(true);
    }, []);

    const off = useCallback(() => {
        setValue(false);
    }, []);

    const toggle = useCallback(() => {
        setValue(it => !it);
    }, []);

    return [value, {on, off, toggle}] as const;
};
